import { connect } from 'react-redux';

import ProviderSurgeIncentiveEdit from './provider-surge-incentive-edit';
import { providerSurgeIncentiveEditForm } from '../actions';

const mapStateToProps = state => ({
  shouldCloseModal: state.providerSurgeIncentive.editRequest.isSuccess
});

const mapDispatchToProps = {
  reset: providerSurgeIncentiveEditForm.reset
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderSurgeIncentiveEdit);
